(() => {
  const MAX_HEIGHT = 135;

  function init(block) {
    const content = block.querySelector(".element-accordion__content");
    if (!content) return;

    // Avoid double init
    if (block.dataset.readmoreInit === "1") return;
    block.dataset.readmoreInit = "1";

    let btn = block.querySelector(".read-more-btn");
    if (btn) btn.remove();

    btn = document.createElement("button");
    btn.type = "button";
    btn.className = "read-more-btn";
    btn.textContent = "Lees meer";
    btn.hidden = true;
    btn.setAttribute("aria-expanded", "false");

    content.after(btn);

    const needsToggle = () => content.scrollHeight > MAX_HEIGHT;

    const collapse = () => {
      content.classList.add("is-collapsed");
      content.style.maxHeight = MAX_HEIGHT + "px";
      btn.textContent = "Lees meer";
      btn.setAttribute("aria-expanded", "false");
    };

    const expand = () => {
      content.classList.remove("is-collapsed");
      content.style.maxHeight = content.scrollHeight + "px";
      btn.textContent = "Lees minder";
      btn.setAttribute("aria-expanded", "true");
    };

    const setup = () => {
      if (!needsToggle()) {
        btn.hidden = true;
        content.style.maxHeight = "none";
        content.classList.remove("is-collapsed");
        btn.textContent = "Lees meer";
        btn.setAttribute("aria-expanded", "false");
        return;
      }

      btn.hidden = false;

      const expanded = btn.getAttribute("aria-expanded") === "true";
      if (!expanded) {
        collapse();
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    };

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const expanded = btn.getAttribute("aria-expanded") === "true";

      if (expanded) {
        content.style.maxHeight = content.scrollHeight + "px";
        content.offsetHeight;
        collapse();
      } else {
        expand();

        const onEnd = (ev) => {
          if (ev.propertyName !== "max-height") return;
          content.removeEventListener("transitionend", onEnd);

          if (btn.getAttribute("aria-expanded") === "true") {
            content.style.maxHeight = "none";
          }
        };

        content.addEventListener("transitionend", onEnd);
      }
    });

    const ro = new ResizeObserver(setup);
    ro.observe(content);

    setup();
  }

  document.querySelectorAll(".product-description").forEach(init);
})();

/**
 * Custom Filter Drawer
 * Slide-out on desktop, full-width popup on mobile
 */
(() => {
  const FILTER_DRAWER_ID = 'FilterDrawer';
  const FILTER_CONTENT_ID = 'FilterDrawerContent';
  const FILTER_SECTION_FETCH_TIMEOUT_MS = 60000; // 60s for large collections
  const SELECTORS = {
    triggerWrapper: '[data-filter-drawer-trigger-wrapper]',
    triggerBtn: '[data-open-drawer="FilterDrawer"]',
    clearBtn: '[data-filter-drawer-clear]',
    closeBtn: '[data-filter-drawer-close]',
    filterForm: '.filter-form',
    filterWrapper: '.filter-wrapper'
  };

  let filtersLoaded = false;
  let isInitialized = false;
  let isFiltering = false;

  function getDrawer() {
    // There may be multiple drawers after AJAX updates
    // Priority: 1) open drawer, 2) last drawer in body
    const allDrawers = document.querySelectorAll(`#${FILTER_DRAWER_ID}`);
    
    let openDrawer = null;
    let lastDrawerInBody = null;
    
    allDrawers.forEach((drawer) => {
      const isOpen = drawer.getAttribute('open') === 'true';
      const isInBody = drawer.parentElement === document.body;
      
      if (isOpen) {
        openDrawer = drawer;
      }
      if (isInBody) {
        lastDrawerInBody = drawer; // Keep updating to get the last one
      }
    });
    
    // First priority: the open drawer
    if (openDrawer) {
      return openDrawer;
    }
    
    // Second priority: last drawer in body (most recent)
    if (lastDrawerInBody) {
      return lastDrawerInBody;
    }
    
    // Fallback: last drawer
    return allDrawers[allDrawers.length - 1] || null;
  }

  /**
   * OverlayDrawer normally opens via per-trigger listeners registered in connectedCallback.
   * If those never attached (late upgrade, empty NodeList at connect, etc.), the drawer stays closed
   * while custom.js still runs loadFilters — so we open explicitly from the delegated click handler.
   */
  function ensureFilterDrawerOpen() {
    cleanupDuplicateDrawers();
    const drawer = getDrawer();
    if (!drawer) return;
    if (drawer.getAttribute('open') === 'true') return;
    try {
      if (typeof drawer.open === 'function') {
        drawer.open();
      } else {
        drawer.setAttribute('open', 'true');
      }
    } catch (e) {
      console.error('[OOR FilterDrawer] ensureFilterDrawerOpen failed', e);
    }
  }

  function cleanupDuplicateDrawers() {
    // Remove old duplicate drawers, keeping only the most recent one
    const allDrawers = document.querySelectorAll(`#${FILTER_DRAWER_ID}`);
    if (allDrawers.length <= 1) return;
    
    // Keep the last drawer (most recent), remove others
    for (let i = 0; i < allDrawers.length - 1; i++) {
      const drawer = allDrawers[i];
      if (drawer.getAttribute('open') !== 'true') {
        drawer.remove();
      }
    }
  }

  function getContentEl() {
    // Content element is inside the drawer which moved to body
    // We must find it within the drawer, not just by ID (there may be duplicates after AJAX)
    const drawer = getDrawer();
    if (drawer) {
      return drawer.querySelector(`#${FILTER_CONTENT_ID}`);
    }
    return null;
  }

  /** Returns true if the filters container has at least one filter option (e.g. checkboxes or price inputs). */
  function hasActualFilterOptions(container) {
    if (!container) return false;
    const form = container.querySelector(SELECTORS.filterForm);
    if (!form) return false;
    return form.querySelector('input, [type="checkbox"], [type="radio"]') !== null;
  }

  function showLargeCollectionMessage(container) {
    if (!container) return;
    container.innerHTML = `
      <div style="text-align: center; padding: 24px 20px; max-width: 360px; margin: 0 auto;">
        <p style="margin: 0 0 12px; font-weight: 500;">Filters are not available for this collection.</p>
        <p style="margin: 0; font-size: 0.9em; opacity: 0.85;">Collections with a very large number of products (5,000+) don't support filters due to platform limits. Try using search or a more specific collection.</p>
      </div>
    `;
  }

  function init() {
    if (isInitialized) return;

    const triggerWrapper = document.querySelector(SELECTORS.triggerWrapper);
    const hasHeaderFilter = document.querySelector('[data-has-header-filter]');

    // Check if we have either a trigger wrapper or header filter
    if (!triggerWrapper && !hasHeaderFilter) return;

    // Show the trigger button only if NOT using header filter
    if (triggerWrapper && !hasHeaderFilter) {
      triggerWrapper.style.display = 'block';
    }

    // Add class to enable drawer mode (hides default sidebar)
    const itemGrid = document.querySelector('.item-grid');
    if (itemGrid) {
      itemGrid.classList.add('filter-drawer-enabled');
    }

    // Setup event listeners (only once)
    setupEventListeners();

    isInitialized = true;
  }

  function setupEventListeners() {
    // Load filters when trigger is clicked
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest(SELECTORS.triggerBtn);
      if (trigger) {
        ensureFilterDrawerOpen();
        // Always reset and load fresh filters when opening
        filtersLoaded = false;
        // Delay to let drawer open and any pending AJAX complete
        setTimeout(() => loadFilters(), 300);
      }
    });

    // Clear button - resets all filters
    document.addEventListener('click', (e) => {
      if (e.target.closest(SELECTORS.clearBtn)) {
        e.preventDefault();
        clearAllFilters();
      }
    });

    // Close: Apply footer + header X — must use the drawer that contains the clicked control
    // (getDrawer() can point at a stale duplicate #FilterDrawer in body after AJAX, so close did nothing)
    document.addEventListener('click', (e) => {
      const applyBtn = e.target.closest(SELECTORS.closeBtn);
      const xBtn = e.target.closest('[data-drawer-close-button]');
      const btn = applyBtn || xBtn;
      if (!btn) return;
      const drawer = btn.closest(`#${FILTER_DRAWER_ID}`);
      if (!drawer) return;
      e.preventDefault();
      closeOverlayDrawer(drawer);
    });

    // Listen for drawer close to reset state
    document.addEventListener('click', (e) => {
      // Check if clicking the overlay/backdrop to close drawer
      const drawer = getDrawer();
      if (drawer) {
        const closeButton = e.target.closest('[data-close-drawer], .overlay-drawer__backdrop, .overlay-drawer__close');
        if (closeButton) {
          // Reset filters loaded state when drawer closes
          setTimeout(() => {
            const isStillOpen = drawer.getAttribute('open') === 'true';
            if (!isStillOpen) {
              filtersLoaded = false;
              resetDrawerContent();
            }
          }, 100);
        }
      }
    });

    // Also listen for the drawer's open attribute changes
    const observeDrawerState = () => {
      const drawer = getDrawer();
      if (drawer) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'open') {
              const isOpen = drawer.getAttribute('open') === 'true';
              if (!isOpen) {
                // Drawer just closed - reset state
                filtersLoaded = false;
                resetDrawerContent();
              }
            }
          });
        });
        observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
      }
    };
    // Observe after a short delay to let drawer initialize
    setTimeout(observeDrawerState, 500);

    // Sort dropdown change
    document.addEventListener('change', (e) => {
      const sortSelect = e.target.closest('[data-filter-drawer-sort-select]');
      if (sortSelect) {
        applySortChange(sortSelect.value);
      }
    });

    // Listen for filter selection (from theme's built-in filters if any)
    document.addEventListener('filter:selected', () => {
      // Don't close drawer, just show loading
      showDrawerLoading();
    });

    // Listen for collection reload to refresh filters in drawer
    document.addEventListener('collection:reloaded', () => {
      // Clean up duplicate drawers that accumulate after AJAX updates
      cleanupDuplicateDrawers();
      
      // Reload filters in drawer if it's open
      const drawer = getDrawer();
      const isDrawerOpen = drawer && drawer.getAttribute('open') === 'true';
      
      if (isDrawerOpen) {
        reloadFiltersInDrawer();
        updateSortDropdown();
      } else {
        filtersLoaded = false;
      }
      updateFilterCount();
      isFiltering = false;
    });
  }

  function updateSortDropdown() {
    // Update the sort dropdown to match the current URL
    const drawer = getDrawer();
    if (!drawer) return;

    const sortSelect = drawer.querySelector('[data-filter-drawer-sort-select]');
    if (!sortSelect) return;

    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    
    if (currentSort) {
      sortSelect.value = currentSort;
    }
  }

  function showDrawerLoading() {
    const contentEl = getContentEl();
    if (contentEl) {
      // Add loading overlay instead of replacing content
      let overlay = contentEl.querySelector('.filter-drawer__overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'filter-drawer__overlay';
        overlay.innerHTML = '<div class="filter-drawer__spinner">Updating...</div>';
        overlay.style.cssText = `
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
          font-weight: bold;
        `;
        contentEl.style.position = 'relative';
        contentEl.appendChild(overlay);
      }
      overlay.style.display = 'flex';
    }
  }

  function hideDrawerLoading() {
    const contentEl = getContentEl();
    if (contentEl) {
      const overlay = contentEl.querySelector('.filter-drawer__overlay');
      if (overlay) {
        overlay.style.display = 'none';
      }
    }
  }

  function getOpenAccordions(container) {
    // Save open accordion state (supports <details>, [open] attr, and common class patterns)
    const openAccordions = [];
    
    // <details> elements
    container.querySelectorAll('details[open]').forEach((el, index) => {
      const id = el.id || el.querySelector('summary')?.textContent?.trim() || `details-${index}`;
      openAccordions.push({ type: 'details', id });
    });
    
    // Elements with open="true" attribute (custom elements)
    container.querySelectorAll('[open="true"]').forEach((el, index) => {
      const id = el.id || el.getAttribute('data-id') || `open-${index}`;
      openAccordions.push({ type: 'attr', id, tagName: el.tagName.toLowerCase() });
    });
    
    // Elements with is-open or is-active class
    container.querySelectorAll('.is-open, .is-active, .accordion--open').forEach((el, index) => {
      const id = el.id || el.getAttribute('data-id') || el.querySelector('[data-accordion-trigger]')?.textContent?.trim() || `class-${index}`;
      openAccordions.push({ type: 'class', id, className: el.classList.contains('is-open') ? 'is-open' : (el.classList.contains('is-active') ? 'is-active' : 'accordion--open') });
    });

    return openAccordions;
  }

  function restoreOpenAccordions(container, openAccordions) {
    openAccordions.forEach((accordion) => {
      let el = null;
      
      if (accordion.type === 'details') {
        // Try to find by id first
        el = accordion.id.startsWith('details-') 
          ? container.querySelectorAll('details')[parseInt(accordion.id.split('-')[1])]
          : container.querySelector(`details#${CSS.escape(accordion.id)}`) || 
            Array.from(container.querySelectorAll('details')).find(d => d.querySelector('summary')?.textContent?.trim() === accordion.id);
        if (el) el.open = true;
      } else if (accordion.type === 'attr') {
        el = accordion.id.startsWith('open-')
          ? container.querySelectorAll(`${accordion.tagName}[open]`)[parseInt(accordion.id.split('-')[1])] ||
            container.querySelectorAll(accordion.tagName)[parseInt(accordion.id.split('-')[1])]
          : container.querySelector(`#${CSS.escape(accordion.id)}`);
        if (el) el.setAttribute('open', 'true');
      } else if (accordion.type === 'class') {
        el = accordion.id.startsWith('class-')
          ? container.querySelectorAll('.accordion, .collapsible, [data-accordion]')[parseInt(accordion.id.split('-')[1])]
          : container.querySelector(`#${CSS.escape(accordion.id)}`);
        if (el) el.classList.add(accordion.className);
      }
    });
  }

  async function reloadFiltersInDrawer() {
    const contentEl = getContentEl();
    if (!contentEl) return;

    // Save current accordion state before reloading
    const openAccordions = getOpenAccordions(contentEl);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), FILTER_SECTION_FETCH_TIMEOUT_MS);

    try {
      const searchParams = window.location.search.slice(1);
      const url = `${window.location.pathname}?section_id=item-grid-filters&${searchParams}`;
      const response = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        },
        signal: controller.signal
      });

      clearTimeout(timeoutId);
      if (!response.ok) throw new Error('Failed to reload filters');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const filters = doc.querySelector(SELECTORS.filterWrapper);

      if (filters) {
        // Process form elements to have unique IDs
        const filterForm = filters.querySelector(SELECTORS.filterForm);
        if (filterForm) {
          Array.from(filterForm.elements).forEach((el) => {
            const id = el.getAttribute('id');
            if (id) {
              const newId = `${id}-drawer`;
              el.setAttribute('id', newId);
              const label = filters.querySelector(`label[for="${id}"]`);
              if (label) {
                label.setAttribute('for', newId);
              }
            }
          });
        }

        contentEl.innerHTML = '';
        contentEl.appendChild(filters);

        if (!hasActualFilterOptions(contentEl)) {
          showLargeCollectionMessage(contentEl);
          hideDrawerLoading();
          filtersLoaded = true;
          return;
        }

        // Execute any JS modules
        const scripts = contentEl.querySelectorAll('script[type="module"]');
        scripts.forEach((script) => {
          const newScript = document.createElement('script');
          newScript.type = 'module';
          if (script.src) {
            newScript.src = script.src;
          } else {
            newScript.textContent = script.textContent;
          }
          script.parentNode.replaceChild(newScript, script);
        });

        // Restore accordion state
        restoreOpenAccordions(contentEl, openAccordions);

        // Setup filter form handling
        setupFilterFormHandling(contentEl);
        
        // Hide loading overlay
        hideDrawerLoading();
        
        filtersLoaded = true;
      } else {
        showLargeCollectionMessage(contentEl);
        hideDrawerLoading();
      }
    } catch (error) {
      clearTimeout(timeoutId);
      console.error('Error reloading filters:', error);
      if (error.name === 'AbortError') {
        showLargeCollectionMessage(contentEl);
      }
      hideDrawerLoading();
    }
  }

  function resetDrawerContent() {
    filtersLoaded = false;
    const contentEl = getContentEl();
    if (contentEl) {
      contentEl.innerHTML = `
        <div class="filter-drawer__loading" style="text-align: center; padding: 40px 0;">
          Loading...
        </div>
      `;
    }
  }

  function setupFilterFormHandling(container) {
    const filterForm = container.querySelector(SELECTORS.filterForm);
    if (!filterForm) return;

    // Listen for changes on checkboxes, radios, and selects
    filterForm.addEventListener('change', (e) => {
      const target = e.target;
      
      // Handle checkbox and radio inputs
      if (target.type === 'checkbox' || target.type === 'radio') {
        applyFiltersFromForm(filterForm);
      }
      
      // Handle select elements
      if (target.tagName === 'SELECT') {
        applyFiltersFromForm(filterForm);
      }
    });

    // Listen for price range changes - stop propagation to prevent theme's once:true listener conflict
    container.addEventListener('price-range:change', (e) => {
      e.stopPropagation(); // Prevent theme's document listener from catching this
      if (e.detail instanceof FormData) {
        applyFiltersFromFormData(e.detail);
      } else {
        applyFiltersFromForm(filterForm);
      }
    });

    // Handle filter links (both add and remove)
    container.addEventListener('click', (e) => {
      // Check for filter add links (contain filter. in URL)
      const filterLink = e.target.closest('a[href*="filter."]');
      if (filterLink) {
        e.preventDefault();
        const href = filterLink.getAttribute('href');
        if (href) {
          applyFiltersFromUrl(href);
        }
        return;
      }

      // Check for filter remove links (tag--remove chips)
      const removeLink = e.target.closest('.tag--remove a, .tag--inline a, .element-chip--active');
      if (removeLink) {
        e.preventDefault();
        const href = removeLink.getAttribute('href');
        if (href) {
          applyFiltersFromUrl(href);
        }
        return;
      }
    });
  }

  function applyFiltersFromForm(form) {
    const formData = new FormData(form);
    applyFiltersFromFormData(formData);
  }

  function applyFiltersFromFormData(formData) {
    if (isFiltering) return;
    isFiltering = true;

    const url = new URL(window.location.href);
    
    // Clear existing filter parameters
    const keysToDelete = [];
    url.searchParams.forEach((value, key) => {
      if (key.startsWith('filter.') || key === 'page') {
        keysToDelete.push(key);
      }
    });
    keysToDelete.forEach(key => url.searchParams.delete(key));

    // Add new filter parameters from form data
    for (const [key, value] of formData.entries()) {
      if (key.startsWith('filter.') && value) {
        // Convert price values to integers (Shopify expects cents as integers)
        if (key.includes('.price.')) {
          const intValue = Math.round(parseFloat(value));
          if (!isNaN(intValue)) {
            url.searchParams.append(key, intValue.toString());
          }
        } else {
          url.searchParams.append(key, value);
        }
      }
    }
    
    // Show loading and apply via AJAX
    showDrawerLoading();
    applyFiltersViaAjax(url);
  }

  function applyFiltersFromUrl(href) {
    if (isFiltering) return;
    isFiltering = true;

    const url = new URL(href, window.location.origin);
    
    // Show loading and apply via AJAX
    showDrawerLoading();
    applyFiltersViaAjax(url);
  }

  function applySortChange(sortValue) {
    if (isFiltering) return;
    isFiltering = true;

    const url = new URL(window.location.href);
    
    // Update or add the sort_by parameter
    if (sortValue) {
      url.searchParams.set('sort_by', sortValue);
    } else {
      url.searchParams.delete('sort_by');
    }
    
    // Reset to page 1 when sorting changes
    url.searchParams.delete('page');

    // Show loading and apply via AJAX
    showDrawerLoading();
    applyFiltersViaAjax(url);
  }

  function applyFiltersViaAjax(url) {
    // Try to use the theme's AJAX system if available
    const event = new CustomEvent('ajaxCollection:render', {
      detail: { newUrl: url },
      bubbles: true
    });
    
    // Update the URL in the browser
    window.history.pushState({}, '', url.toString());
    
    // Dispatch the event to trigger AJAX update
    document.dispatchEvent(event);
    
    // Fallback: if no AJAX handler responds within 3 seconds, do a full reload
    setTimeout(() => {
      if (isFiltering) {
        window.location.href = url.toString();
      }
    }, 3000);
  }

  async function loadFilters(retryCount = 0) {
    const contentEl = getContentEl();

    if (!contentEl) {
      return;
    }

    // Remove any existing overlay from previous sessions
    const existingOverlay = contentEl.querySelector('.filter-drawer__overlay');
    if (existingOverlay) {
      existingOverlay.remove();
    }

    // Show loading state
    contentEl.innerHTML = `
      <div class="filter-drawer__loading" style="text-align: center; padding: 40px 0;">
        Loading...
      </div>
    `;

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), FILTER_SECTION_FETCH_TIMEOUT_MS);

    try {
      const searchParams = window.location.search.slice(1);
      const url = `${window.location.pathname}?section_id=item-grid-filters&${searchParams}`;
      
      const response = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        },
        signal: controller.signal
      });

      clearTimeout(timeoutId);
      if (!response.ok) throw new Error('Failed to load filters');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const filters = doc.querySelector(SELECTORS.filterWrapper);

      if (filters) {
        // Process form elements to have unique IDs
        const filterForm = filters.querySelector(SELECTORS.filterForm);
        if (filterForm) {
          Array.from(filterForm.elements).forEach((el) => {
            const id = el.getAttribute('id');
            if (id) {
              const newId = `${id}-drawer`;
              el.setAttribute('id', newId);
              const label = filters.querySelector(`label[for="${id}"]`);
              if (label) {
                label.setAttribute('for', newId);
              }
            }
          });
        }

        contentEl.innerHTML = '';
        contentEl.appendChild(filters);

        if (!hasActualFilterOptions(contentEl)) {
          showLargeCollectionMessage(contentEl);
          hideDrawerLoading();
          filtersLoaded = true;
          return;
        }

        // Execute any JS modules in the filters
        const scripts = contentEl.querySelectorAll('script[type="module"]');
        scripts.forEach((script) => {
          const newScript = document.createElement('script');
          newScript.type = 'module';
          if (script.src) {
            newScript.src = script.src;
          } else {
            newScript.textContent = script.textContent;
          }
          script.parentNode.replaceChild(newScript, script);
        });

        // Setup filter form change handling
        setupFilterFormHandling(contentEl);

        // Make sure loading overlay is hidden
        hideDrawerLoading();

        filtersLoaded = true;
      } else {
        showLargeCollectionMessage(contentEl);
      }
    } catch (error) {
      clearTimeout(timeoutId);
      const isTimeout = error.name === 'AbortError';
      const isNetwork = error.message === 'Failed to fetch' || error.message === 'Load failed';
      // Don't retry on timeout or network failure (likely large collection)
      if (!isTimeout && !isNetwork && retryCount < 2) {
        setTimeout(() => loadFilters(retryCount + 1), (retryCount + 1) * 500);
        return;
      }
      
      const contentEl = getContentEl();
      if (contentEl) {
        const message = isTimeout
          ? 'Filters are taking too long to load. This can happen on very large collections (5,000+ products). Try using search or a more specific collection.'
          : 'Filters could not be loaded. This can happen on very large collections. Try refreshing or using search.';
        contentEl.innerHTML = `
          <div style="text-align: center; padding: 24px 20px;">
            <p style="margin: 0 0 12px;">${message}</p>
            <button type="button" class="element-button" onclick="window.location.reload()" style="margin-top: 12px;">
              Reload page
            </button>
          </div>
        `;
      }
    }
  }

  function clearAllFilters() {
    if (isFiltering) return;
    isFiltering = true;

    // Build URL without filter parameters
    const url = new URL(window.location.href);
    const keysToDelete = [];
    
    url.searchParams.forEach((value, key) => {
      // Keep sort_by and other non-filter params
      if (key.startsWith('filter.') || key === 'page') {
        keysToDelete.push(key);
      }
    });

    keysToDelete.forEach(key => url.searchParams.delete(key));
    
    // Show loading and apply via AJAX
    showDrawerLoading();
    applyFiltersViaAjax(url);
  }

  function closeOverlayDrawer(drawer) {
    if (!drawer) return;
    if (typeof drawer.close === 'function') {
      drawer.close();
    } else {
      drawer.setAttribute('open', 'false');
    }
  }

  function updateFilterCount() {
    // Update the filter count on the trigger button after AJAX reload
    // Count active filters from URL
    const urlParams = new URLSearchParams(window.location.search);
    let filterCount = 0;
    
    for (const [key, value] of urlParams.entries()) {
      if (key.startsWith('filter.') && value) {
        filterCount++;
      }
    }
    
    // Update all filter count badges (controls trigger and header trigger)
    const countElements = document.querySelectorAll('.filter-drawer-trigger__count');
    countElements.forEach(countEl => {
      if (filterCount > 0) {
        countEl.textContent = filterCount;
        countEl.style.display = 'inline-flex';
      } else {
        countEl.style.display = 'none';
      }
    });
    
    // Also update header-specific count badge
    const headerCountEl = document.querySelector('[data-header-filter-count]');
    if (headerCountEl) {
      if (filterCount > 0) {
        headerCountEl.textContent = filterCount;
        headerCountEl.style.display = 'inline-flex';
      } else {
        headerCountEl.style.display = 'none';
      }
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after AJAX navigation (but don't re-add event listeners)
  document.addEventListener('collection:reloaded', () => {
    // Just update the UI, event listeners are already set
    const triggerWrapper = document.querySelector(SELECTORS.triggerWrapper);
    if (triggerWrapper) {
      triggerWrapper.style.display = 'block';
    }
    const itemGrid = document.querySelector('.item-grid');
    if (itemGrid) {
      itemGrid.classList.add('filter-drawer-enabled');
    }
  });
})();

/**
 * Safari Variant Selection Fix
 * 
 * Safari has a known bug where clicking on interactive elements (like <button>)
 * inside a <label> does not trigger the associated input's click/change event.
 * 
 * The variant picker uses radio inputs inside labels with button elements as
 * the visible UI. This fix intercepts clicks on those buttons and manually
 * triggers the radio input selection.
 */
(() => {
  // Only apply fix for Safari
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (!isSafari) return;

  document.addEventListener('click', (e) => {
    // Check if click is on a button inside a variant picker label
    const button = e.target.closest('.element-radio .element-button, .element-radio button');
    if (!button) return;

    // Find the parent label
    const label = button.closest('label.element-radio');
    if (!label) return;

    // Find the radio input inside the label
    const radioInput = label.querySelector('input[type="radio"]');
    if (!radioInput || radioInput.disabled) return;

    // Check if this is within a variant picker context
    const variantPicker = label.closest('block-variant-picker');
    if (!variantPicker) return;

    // Prevent the button's default behavior
    e.preventDefault();
    e.stopPropagation();

    // Only proceed if the radio isn't already checked
    if (radioInput.checked) return;

    // Check the radio input
    radioInput.checked = true;

    // Dispatch a change event to trigger the variant picker's handler
    const changeEvent = new Event('change', {
      bubbles: true,
      cancelable: true
    });
    radioInput.dispatchEvent(changeEvent);
  }, true); // Use capture phase to intercept before other handlers
})();

/**
 * Disable right-click (context menu) to discourage saving images.
 * Note: this is a UX deterrent, not a secure anti-download mechanism.
 */
(() => {
  const ALLOW_ATTR = 'data-allow-context-menu';

  const shouldAllowContextMenu = (target) => {
    if (!(target instanceof Element)) return true;
    if (target.closest(`[${ALLOW_ATTR}]`)) return true;

    // Allow standard editing/selecting interactions in form fields.
    const editable = target.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"]');
    if (editable) return true;

    return false;
  };

  const isImageLikeTarget = (target) => {
    if (!(target instanceof Element)) return false;
    return Boolean(
      target.closest('img, picture, svg, video, canvas, [style*="background-image"]')
    );
  };

  document.addEventListener(
    'contextmenu',
    (e) => {
      // If we want a "no right click anywhere" behavior, remove the image check.
      if (!isImageLikeTarget(e.target)) return;
      if (shouldAllowContextMenu(e.target)) return;

      e.preventDefault();
    },
    { capture: true }
  );

  // Also prevent drag-to-desktop/save for images in many browsers.
  document.addEventListener(
    'dragstart',
    (e) => {
      const el = e.target;
      if (!(el instanceof Element)) return;
      if (el.closest('img')) e.preventDefault();
    },
    { capture: true }
  );
})();
